import React from "react";
import ReactECharts from "echarts-for-react";

const TotalDealerRevenueData = ({
  year = "Year",
  yearVal = "0.0",
  ytd = "YTD",
  ytdVal = "0.0",
  graphData,
  divisor = 10000000,
  suffix = " Cr",
}) => {
  const categories = [
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
  ];

  const now = new Date();
  const currentMonth = now.getMonth(); // 0-11
  const currentYear = now.getFullYear();

  // Fiscal month index (Apr=0, ..., Mar=11)
  const fiscalMonthIndex = (currentMonth + 9) % 12;

  // Fiscal End Year (If Apr-Dec, the fiscal year ends next calendar year)
  const fiscalEndYear = currentMonth < 3 ? currentYear : currentYear + 1;
  const fiscalEndYearSuffix = (fiscalEndYear % 100).toString();
  const isCurrentFY = year.includes(fiscalEndYearSuffix);

  const chartData = graphData || {};
  const values = categories.map((month, index) => {
    // If we are looking at the current fiscal year, cutoff future months
    // We use null instead of 0 for future months to avoid plotting zero points
    if (isCurrentFY && index > fiscalMonthIndex) {
      return null;
    }
    const val = chartData[month] || 0;
    return (val / divisor).toFixed(2);
  });

  const options = {
    color: ["#3b82f6"],
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "none" },
      formatter: (params) => {
        return `${params[0].name}: ${params[0].value}${suffix}`;
      },
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "25%",
      top: "40%",
      containLabel: false,
    },
    xAxis: {
      type: "category",
      data: categories,
      boundaryGap: true,
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: { color: "#64748b", fontSize: 10, interval: 0, rotate: -45 },
      splitLine: { show: false },
    },
    yAxis: {
      type: "value",
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: { show: false },
      splitLine: { show: false },
    },
    series: [
      {
        name: "Revenue",
        type: "line",
        data: values,
        smooth: true,
        symbol: "circle",
        symbolSize: 6,
        itemStyle: {
          color: "#fff",
          borderColor: "#3b82f6",
          borderWidth: 2,
        },
        lineStyle: { width: 2, color: "#3b82f6" },
        label: {
          show: true,
          position: "top",
          rotate: 90,
          distance: 5,
          verticalAlign: "middle",
          align: "left",
          fontSize: 8,
          fontWeight: "bold",
          color: "#3b82f6",
          formatter: (params) => {
            return params.value ? `${params.value}${suffix}` : "";
          },
        },
        areaStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: "rgba(59, 130, 246, 0.3)" },
              { offset: 1, color: "rgba(59, 130, 246, 0.01)" },
            ],
          },
        },
      },
    ],
  };

  return (
    <div className="w-full flex items-center h-full px-2">
      {/* Year Section */}
      <div className="flex flex-col items-center justify-center p-2 min-w-[100px]">
        <p className="text-xs text-gray-800 font-medium whitespace-nowrap">
          {year?.replace(/_/g, " ")}
        </p>
        <p className="text-md font-bold text-[#d97706] mt-1">{yearVal}</p>
      </div>

      {/* Vertical Divider */}

      <div className="flex items-center h-20">
        <div className="inline-block h-full w-0.5 self-stretch bg-gray-200"></div>
      </div>

      {/* YTD Section */}
      <div className="flex flex-col items-center justify-center p-2 min-w-[80px]">
        <p className="text-xs text-gray-800 font-medium whitespace-nowrap">
          {ytd?.replace(/_/g, " ")}
        </p>
        <p className="text-md font-bold text-gray-800 mt-1">{ytdVal}</p>
      </div>

      {/* Vertical Divider */}
      <div className="flex items-center h-20">
        <div className="inline-block h-full w-0.5 self-stretch bg-gray-200"></div>
      </div>

      {/* Graph Section */}
      <div className="flex-1 h-full py-1 flex items-center justify-center">
        <ReactECharts
          option={options}
          style={{ height: "100%", width: "100%", minHeight: "80px" }}
        />
      </div>
    </div>
  );
};

export default TotalDealerRevenueData;
